import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LoaderScreenServiceV2 } from './services/loader-screen/loader-screen.service';
import { OverlayContainerService } from './services/overlay-container/overlay-container.service';
import { PathsService } from './services/paths/paths.service';
import { PortalConfigurationService } from './services/portal-configuration/portal-configuration.service';

import { AuthModuleGuard } from './guards/auth-module.guard';
import { LoginModuleGuard } from './guards/login-module.guard';
import { PipesModule } from './pipes/pipes.module';
import { AuthenticationService } from './services/authentication/authentication.service';
import { BreadcrumbNavigationService } from './services/breadcrumb-navigation/breadcrumb-navigation.service';
import { BroadcasterService } from './services/broadcaster/broadcaster.service';
import { CartService } from './services/cart/cart.service';
import { ConfigurationService } from './services/configuration/configuration.service';
import { CoursesService } from './services/courses/courses.services';
import { DeviceDetectService } from './services/device-detect/device-detect.service';
import { DynamicComponentBroadcasterService } from './services/dynamic-component/dynamic-component-broadcaster.service';
import { DynamicComponentService } from './services/dynamic-component/dynamic-component.service';
import { EnvironmentService } from './services/environment/environment.service';

import { ErrorBroadcastService } from './services/error-broadcast/error-broadcast.service';
import { ErrorHandlingService } from './services/error-handling/error-handling.service';
import { HttpErrorInterceptor } from './services/error-handling/httperrorinterceptor.service';
import { FeatureService } from './services/feature/feature.service';
import { GlobalAssetsService } from './services/global-assets/global-assets.service';
import { LinkService } from './services/link/link.service';
import { LoadScriptService } from './services/load-script/load-script.service';
import { MetadataBuilder } from './services/metadata/metadata-builder';
import { MockService } from './services/mock/mock.service';
import { NavigationMockService } from './services/mock/navigation-mock.service';
import { NavigationService } from './services/navigation/navigation.service';
import { PreviewManagementService } from './services/preview-management/preview-management.service';
import { RestApiService } from './services/rest-api/rest-api.service';
import { RouteManagementService } from './services/route-management/route-management.service';
import { ScrollOnLoadService } from './services/scroll-on-load/scroll-on-load.service';
import { SearchService } from './services/search/search.service';
import { SiteSettingsService } from './services/site-settings/site-settings.service';
import { LocalStorageService } from './services/storage/local-storage.service';
import { SessionStorageService } from './services/storage/session-storage.service';
import { StorageAndCookieService } from './services/storage/storage-and-cookie.service';
import { TrackingV2Service } from './services/trackingv2/trackingv2.service';
import { TranslationService } from './services/translation/translation.service';
import { UrlService } from './services/url/url.service';
import { UserManagementService } from './services/user-management/user-management.service';
import { UserService } from './services/user-management/user.service';
import { OrderService } from './services/order/order.service';
import { AscService } from './services/acs-input/acs.service';

const SHARED_MODULES = [PipesModule];

const SHARED_MODULE_COMPONENTS = [];

const SHARED_MODULE_DIRECTIVES = [];

const DECLARATIONS = [];

const MODULE_PROVIDERS = [
    BroadcasterService,

    ConfigurationService,
    NavigationService,
    ErrorBroadcastService,
    ErrorHandlingService,
    LinkService,
    LoadScriptService,

    MetadataBuilder,
    MockService,
    GlobalAssetsService,
    RestApiService,
    LocalStorageService,
    SessionStorageService,
    StorageAndCookieService,
    TrackingV2Service,
    UrlService,
    UserManagementService,
    RouteManagementService,
    UserService,
    AuthModuleGuard,
    LoginModuleGuard,
    DynamicComponentBroadcasterService,
    DynamicComponentService,
    DeviceDetectService,
    ScrollOnLoadService,
    LoaderScreenServiceV2,
    OverlayContainerService,
    FeatureService,
    CoursesService,
    NavigationMockService,
    TranslationService,
    SiteSettingsService,
    EnvironmentService,
    BreadcrumbNavigationService,
    PreviewManagementService,
    AuthenticationService,
    CartService,
    SearchService,
    PathsService,
    PortalConfigurationService,
    AscService,
    OrderService,
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpErrorInterceptor,
        multi: true
    }
];

@NgModule({
    imports: [...SHARED_MODULES],
    declarations: [...DECLARATIONS, ...SHARED_MODULE_COMPONENTS, ...SHARED_MODULE_DIRECTIVES],
    exports: [...DECLARATIONS, ...SHARED_MODULE_COMPONENTS, ...SHARED_MODULES, ...SHARED_MODULE_DIRECTIVES]
})
export class AcademyCommonModule {
    static forRoot(): ModuleWithProviders<AcademyCommonModule> {
        return {
            ngModule: AcademyCommonModule,
            providers: [...MODULE_PROVIDERS]
        };
    }
}
